// --------------------------------------------------------------------------
// #237 Donation Amount Confirmation
// --------------------------------------------------------------------------
// Author:      Alix Richards, Tom Morris
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context, $document: $(document) };
    var state = { monthly: null, amount: '0' };

    function updateFormValues() {
        var url = window.location.pathname;

        // Do not update the form values if the amount is empty which results in 500 error from the server
        if (state.amount.length === 0) {
            return;
        }

        // Allow for missing trailing slash
        if (url.substr(-1) !== '/') {
            url += '/';
        }

        $.ajax({
            data: '&amount=' + state.amount + '&isMonthly=' + state.monthly + '&__RequestVerificationToken=' + ref.$token.val() + '&' + 'UpdateForm=',
            type: 'POST',
            url: url + 'updateform/',
            dataType: 'json',
            success: function success(data) {
                if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data.result === 'OperationSuccessful') {
                    /// Clear the form
                    ref.$root.find('input[name="x_fp_hash"], input[name="x_fp_sequence"], input[name="x_fp_timestamp"], input[name="x_login"], input[name="x_amount"], input[name="x_relay_url"], input[name="x_relay_response"]').remove();
                    ref.$isMonthly.val(data.ismonthly);
                    /// update submit options
                    if (state.monthly) {
                        ref.$form.attr('action', ref.$currentUrl.val());
                    } else {
                        var ccformhtml = $.parseHTML(data.ccform);
                        ref.$form.append(ccformhtml);
                        ref.$form.attr('action', data.authorizeurl);
                    }
                }
            }
        });

        // broadcast amount change to external listeners, e.g. ApplePay
        ref.$document.trigger('donation-amount-confirmation:change', [state.amount, state.monthly]);
    }

    function render() {
        ref.$amountConfirmation.text(state.amount);
        ref.$monthlyCopy.toggleClass('active', state.monthly);
    }

    function isRadioMonthly($radio) {
        return $radio.attr('id').indexOf('monthly') !== -1;
    }

    function onUpdateMonthlyAmount(event, amount) {
        state.monthly = true;
        state.amount = amount;

        /// Update UI + call BE ajax
        render();
        updateFormValues();
    }

    function init() {
        ref.$donationRadios = ref.$root.find('[data-name="donation-radio"]');
        ref.$amountConfirmation = ref.$root.find('[data-donation]');
        ref.$monthlyCopy = ref.$root.find('[data-donation-copy]');
        ref.$form = ref.$root.find('form');
        ref.$token = ref.$root.find('input[name="__RequestVerificationToken"]');
        ref.$currentUrl = ref.$root.find('#CurrentPageUrl');
        ref.$isMonthly = ref.$root.find('input[name="DonationOptions.IsMonthly"]');

        /// Work out initial state
        var $selectedRadio = ref.$donationRadios.filter(':checked');

        if (!!$selectedRadio.length) {
            var $selectedRadioCustom = $selectedRadio.parent().find('[data-name="personalised-donation"]');

            /// Check if the selected radio has a custom input
            state.amount = !!$selectedRadioCustom.length ? $selectedRadioCustom.val() : $selectedRadio.val();

            /// Update monthly
            state.monthly = isRadioMonthly($selectedRadio);
        } else {
            /// Update monthly
            var $selectedTab = ref.$root.find('[data-binding="donation-tabs"]').filter('.active');
            state.monthly = !!$selectedTab.length && $selectedTab.attr('data-state') === 'monthly';
        }

        /// Listen to external monthly change values, e.g. from lottery
        ref.$document.on('donation-amount-confirmation:updateMonthlyAmount', onUpdateMonthlyAmount);

        /// Listen to changes on radio buttons
        ref.$root.on('change', '[data-name="radio-option"]', function () {
            var $option = $(this);
            var $radio = $option.find('[data-name="donation-radio"]');
            var $personalisedDonation = $option.find('[data-name="personalised-donation"]');

            /// Do we have a custom input?
            if (!!$personalisedDonation.length) {
                /// Yes
                state.amount = '0';
            } else {
                /// No
                state.amount = $radio.val();
            }

            /// Update monthly
            state.monthly = isRadioMonthly($radio);

            /// Update UI + call BE ajax
            render();
            updateFormValues();
        });

        /// Listen to keyup and blur on custom inputs
        ref.$root.on('keyup', '[data-name="personalised-donation"]', function () {
            var $input = $(this);
            var $radio = $input.parents('[data-name="radio-option"]').find('[data-target="custom-amount"]');

            if ($radio.is(':checked')) {
                /// set state amount = value of the $input
                state.amount = $input.val();

                /// Update UI + call BE ajax
                render();
                updateFormValues();
            }
        });

        // Prevent input change form triggering change on option
        ref.$root.on('change', '[data-name="personalised-donation"]', function (event) {
            event.stopPropagation();
        });

        // Additional validation for the look up address that jQuery.validate ignores
        // due to address-part-* input fields being hidden
        ref.$form.on('submit', function (event) {
            var streetAddress = ref.$form.find('[data-binding="address-part-street-address"]').first().val() || '';

            // ignore the check for ApplePay payments
            if (ref.$root.find('[data-name="apple-pay"]').hasClass('inactive')) {
                if (streetAddress.length === 0) {
                    var messageError = 'No address provided. Please click the "Look up address" button to choose your address.';
                    // remove any previous error message
                    ref.$form.find('[data-name="donation-form-custom-postcode-error"]').remove();
                    // display the new validation error message
                    ref.$form.find('[data-binding="postcode-lookup-wrapper"]').prepend('<div class="validation-summary" data-name="donation-form-custom-postcode-error"><div class="validation-summary-errors"><li>' + messageError + '</li></div></div>');
                    // add a custom bottom margin
                    ref.$form.find('[data-name="donation-form-custom-postcode-error"]').css('margin-bottom', '20px');

                    // re-enable the Submit button disabled by the jQuery.validate method that didn't check
                    // for hidden address lookup fields, run in another JavaScript Event Loop
                    setTimeout(function () {
                        ref.$form.trigger('reset-submit');
                    }, 0);
                    return false;
                } else {
                    ref.$form.find('[data-name="donation-form-custom-postcode-error"]').remove();
                }
            }
        });

        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/donation-amount-confirmation.js
// module id = 273
// module chunks = 0